import React from "react";
import "./landing.css";

/* On-brand fake ClassBoon UI used in place of stock photos on the public
   pages. Pure markup + landing.css — no external image assets. */

const Avatar = ({ color, initials }) => (
  <span className="mock-avatar" style={{ background: color }}>
    {initials}
  </span>
);

const Frame = ({ title, variant = "", children }) => (
  <div className={`mock ${variant}`}>
    <div className="mock-bar">
      <div className="mock-dots">
        <i />
        <i />
        <i />
      </div>
      <span className="mock-title">{title}</span>
    </div>
    <div className="mock-body">{children}</div>
  </div>
);

export function SignOutMockup() {
  return (
    <Frame title="classBoon · Sign-Out">
      <div className="mock-head">
        <h4>Who's out right now</h4>
        <span className="mock-count">3 out</span>
      </div>

      <div className="mock-row">
        <Avatar color="#6b8fb0" initials="EM" />
        <span className="mock-name">Ellie M.</span>
        <span className="mock-pill" style={{ background: "#eef3f8", color: "#3d6286" }}>
          🚻 Bathroom
        </span>
        <span className="mock-time">4:12</span>
      </div>
      <div className="mock-row">
        <Avatar color="#c98a5e" initials="JT" />
        <span className="mock-name">Jayden T.</span>
        <span className="mock-pill" style={{ background: "#fdeef0", color: "#b4231f" }}>
          🏥 Nurse
        </span>
        <span className="mock-time">4:05</span>
      </div>
      <div className="mock-row">
        <Avatar color="#5fa37f" initials="MG" />
        <span className="mock-name">Maria G.</span>
        <span className="mock-pill" style={{ background: "#eaf4ff", color: "#2563eb" }}>
          🚰 Water
        </span>
        <span className="mock-time">4:18</span>
      </div>

      <button className="mock-btn">+ Sign a student out</button>
    </Frame>
  );
}

export function AttendanceMockup() {
  const roster = [
    { name: "Ava P.", checked: true },
    { name: "Liam R.", checked: true },
    { name: "Noah K.", checked: true },
    { name: "Sofia D.", checked: false },
    { name: "Ethan B.", checked: true },
    { name: "Mia L.", checked: false },
  ];

  return (
    <Frame title="classBoon · Attendance">
      <div className="mock-head">
        <h4>Period 3 · Homeroom</h4>
        <span className="mock-count">4 / 6 here</span>
      </div>
      <div className="mock-grid">
        {roster.map((s) => (
          <span key={s.name} className={`mock-chip ${s.checked ? "checked" : ""}`}>
            <span className="dot">{s.checked ? "✓" : ""}</span>
            {s.name}
          </span>
        ))}
      </div>
    </Frame>
  );
}

export function EmergencyMockup() {
  return (
    <Frame title="classBoon · Emergency" variant="mock--emergency">
      <div className="mock-head">
        <h4>Emergency Mode</h4>
        <span className="mock-live">
          <i /> LIVE
        </span>
      </div>
      <div className="mock-progress">
        <span style={{ width: "92%" }} />
      </div>
      <div className="mock-row">
        <Avatar color="#5fa37f" initials="3B" />
        <span className="mock-name">Room 3B · Carter</span>
        <span className="mock-pill" style={{ background: "#e7f6ec", color: "#15703a" }}>
          24 / 24 ✓
        </span>
      </div>
      <div className="mock-row">
        <Avatar color="#6b8fb0" initials="5A" />
        <span className="mock-name">Room 5A · Nguyen</span>
        <span className="mock-pill" style={{ background: "#e7f6ec", color: "#15703a" }}>
          22 / 22 ✓
        </span>
      </div>
      <div className="mock-row">
        <Avatar color="#c98a5e" initials="2C" />
        <span className="mock-name">Room 2C · Diaz</span>
        <span className="mock-pill" style={{ background: "#fff4e0", color: "#a35a00" }}>
          19 / 20
        </span>
      </div>
    </Frame>
  );
}
